// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__gYTGO","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__28TUb"};